import { localize } from '@vee-validate/i18n'
import { all } from '@vee-validate/rules'
import { configure, defineRule } from 'vee-validate'

// Register every vee-validate rule globally so the string rules on App* inputs (e.g.
// rules="required") resolve when a field validates. Without this, vee-validate v4 throws
// "No such validator '<name>' exists" on validate/submit and the form's @submit never fires —
// which would silently break the login flow. structure.md lists this as a required lib.
Object.entries(all).forEach(([name, rule]) => {
    defineRule(name, rule)
})

// English validation messages. {field} resolves to the input's label.
configure({
    generateMessage: localize('en', {
        messages: {
            required: 'The {field} field is required.',
        },
    }),
})
